export const processTypes = {
  RENEWAL: 'renewal',
  JOIN: 'join',
};
